import { Row, Col, Card, Form } from "react-bootstrap";
import Select from "react-select";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import classes from "./createReturn.module.scss";

import { customStyles } from "./createReturn.constants";

import api from "@/services/api.service";
import { dateToLocale } from "@/services/Utils";
import { textConstants } from "@/languages/textConstants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const CreateReturnHead = ({ data, setData, setItems, dealers, ordersSale, ordersDelivery, activeDetail, setActiveDetail, setIsFetching }) => {
	const { option } = useParams();

	const { filter } = useSelector((state) => state.auth);
	const { customer } = useSelector((state) => state.auth.user);
	const { type_currency } = filter;

	const typesDocument = [
		{ value: 1, label: "Factura" },
		{ value: 2, label: textConstants[customer.country_id].delivery },
	];

	const selectDealer = dealers.find((d) => String(d.value) === String(data.dealer_id));

	const ChangeSale = (value) => {
		setIsFetching(true);
		api.get("/client/orders_return/detail", {
			type_document: data.type_document,
			order_sale_id: value.value,
			order_delivery_id: "",
			type_currency,
			dealer_id: value.dealer_id,
		}).then((response) => {
			setIsFetching(false);
			setItems(response.items);
			setData({
				...data,
				order_delivery_id: "",
				dealer_id: value.dealer_id,
				rut_dealer: value.rut_dealer,
				order_sale_id: value.value,
				details: response.items,
			});
		});
	};

	const ChangeDelivery = (value) => {
		setIsFetching(true);
		api.get("/client/orders_return/detail", {
			type_document: data.type_document,
			order_sale_id: "",
			order_delivery_id: value.value,
			type_currency,
			dealer_id: value.dealer_id,
		}).then((response) => {
			setIsFetching(false);
			setItems(response.items);
			setData({
				...data,
				order_sale_id: "",
				dealer_id: value.dealer_id,
				rut_dealer: value.rut_dealer,
				order_delivery_id: value.value,
				details: response.items,
			});
		});
	};

	const handleDealer = (value) => {
		setData({ ...data, dealer_id: value });
	};

	const handleTypeDocument = (value) => {
		setData({
			...data,
			type_document: value,
			order_sale_id: "",
			order_delivery_id: "",
			details: [],
		});
	};

	return (
		<Col md={12} className={classes.col_base}>
			<Card className={activeDetail && "active"}>
				<Card.Header onClick={() => setActiveDetail(!activeDetail)} className={activeDetail && "active"}>
					Detalle
					<div>
						{["ver", "editar"].includes(option) && (
							<>
								<span>
									<strong> Usuario:</strong>
									{` ${data.user_name ? data.user_name : ""}`}
								</span>
								<span>
									<strong> Fecha:</strong>
									{` ${data.created_at ? dateToLocale(data.created_at) : ""}`}
								</span>
							</>
						)}

						<span>
							<strong> N° Nota Crédito:</strong>
							{` ${data.code ? data.code : ""}`}
						</span>
						<span style={{ marginRight: "1em" }}>
							<strong> Distribuidor:</strong>
							{` ${selectDealer ? selectDealer.label : ""}`}
						</span>
					</div>
				</Card.Header>
				{activeDetail && (
					<Card.Body>
						<Row className={classes.header}>
							<Col md={6} sm={12} className={classes.headerLeft}>
								<div className={classes.divInput}>
									<div className={classes.inputForm}>
										<div className={classes.inputText}>N° Nota de Crédito</div>
										<div>
											<Form.Control
												className={classes.input}
												type="text"
												value={data.code ? data.code : ""}
												onChange={(e) =>
													setData({
														...data,
														code: e.target.value,
													})
												}
												readOnly={option === "ingresar" ? false : true}
											/>
										</div>
									</div>

									<div className={classes.inputForm}>
										<div className={classes.inputText}>Distribuidor</div>
										<div>
											<Select
												styles={customStyles}
												value={dealers && dealers.filter((b) => Number(b.value) === Number(data.dealer_id))}
												placeholder={<div>Seleccione</div>}
												options={dealers}
												onChange={(value) => handleDealer(value.value)}
												isDisabled={option === "ingresar" ? false : true}
											/>
										</div>
									</div>
								</div>
							</Col>
							<Col md={6} sm={12} className={classes.headerRight}>
								<div className={classes.divInput}>
									<div className={classes.inputForm}>
										<div className={classes.inputText}>Tipo de Documento</div>
										<div>
											<Select
												styles={customStyles}
												value={typesDocument && typesDocument.filter((b) => Number(b.value) === Number(data.type_document))}
												placeholder={<div>Seleccione</div>}
												options={typesDocument}
												onChange={(value) => handleTypeDocument(value.value)}
												isDisabled={option === "ingresar" ? false : true}
											/>
										</div>
									</div>

									{Number(data.type_document) === 1 && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>Factura</div>
											<div>
												<Select
													styles={customStyles}
													value={ordersSale && ordersSale.filter((b) => Number(b.value) === Number(data.order_sale_id))}
													placeholder={<div>Seleccione</div>}
													options={
														data.dealer_id
															? ordersSale && ordersSale.filter((os) => Number(os.dealer_id) === Number(data.dealer_id))
															: ordersSale
													}
													onChange={(value) => ChangeSale(value)}
													isDisabled={option === "ingresar" ? false : true}
													components={{
														NoOptionsMessage,
													}}
												/>
											</div>
										</div>
									)}

									{Number(data.type_document) === 2 && (
										<div className={classes.inputForm}>
											<div className={classes.inputText}>{textConstants[customer.country_id].delivery}</div>
											<div>
												<Select
													styles={customStyles}
													value={ordersDelivery && ordersDelivery.filter((b) => Number(b.value) === Number(data.order_delivery_id))}
													placeholder={<div>Seleccione</div>}
													options={
														data.dealer_id
															? ordersDelivery && ordersDelivery.filter((od) => Number(od.dealer_id) === Number(data.dealer_id))
															: ordersDelivery
													}
													onChange={(value) => ChangeDelivery(value)}
													isDisabled={option === "ingresar" ? false : true}
													components={{
														NoOptionsMessage,
													}}
												/>
											</div>
										</div>
									)}
								</div>
							</Col>
						</Row>
					</Card.Body>
				)}
			</Card>
		</Col>
	);
};

export default CreateReturnHead;
